import { Unit } from '../../../../shared/common/units';
import { TrendingUnitType, UnitsAdaptee } from '../units.model';

export class TrendingAdaptee implements UnitsAdaptee {
  constructor() {}

  standardizeUnit(unit: Unit | string): string {
    switch (unit) {
      case TrendingUnitType.Celsius:
        return Unit.Celsius;
      case TrendingUnitType.LitersPerHour:
        return Unit.LiterHour;
      case TrendingUnitType.Percent:
        return Unit.Percent;
      default: {
        return unit;
      }
    }
  }
}
